<script lang="ts">
  import { Button, Dialog, Markdown } from '@bruce/components'
  import GeneralUsp from './GeneralUsp.svelte'
  import type { GeneralUsps } from '@bruce/api/common/usps'

  export let usps: GeneralUsps

  let showDialog: number | null = null

  function handleVisible(visible: boolean) {
    if (!visible) {
      showDialog = null
    }
  }
</script>

<ul>
  {#each usps as usp, index (usp.id)}
    <li>
      <GeneralUsp>{usp.title}</GeneralUsp>
      {#if usp.note}
        <Button
          icon="ph-info"
          type="button"
          variant="text"
          rounded
          on:click={() => (showDialog = index)}
        />
        <Dialog
          visible={showDialog === index}
          on:toggleVisible={(event) => handleVisible(event.detail.visible)}
        >
          <h2 slot="title">{usp.note_title || usp.title}</h2>
          <div slot="content">
            <Markdown source={usp.note} />
          </div>
        </Dialog>
      {/if}
    </li>
  {/each}
</ul>

<style lang="scss">
  @use '@bruce/assets/css/breakpoints';

  ul {
    display: flex;
    list-style-type: none;
    gap: 1em;
    padding: 0;

    @media screen and (max-width: breakpoints.$breakpoint-sm) {
      flex-direction: column;
      gap: 0.5em;
    }

    li {
      display: flex;
      gap: 0.5em;
      height: 40px;
    }
  }
</style>
